import React, { useEffect } from 'react';
import Footer from '../../components/modules/Footer';
import Navbar from '../../components/modules/Navbar';
import './EditionStyles.css';
import ScrollTrigger from 'gsap/ScrollTrigger';
import ScrollToPlugin from 'gsap/ScrollToPlugin';
import gsap from 'gsap';
import { Link as LinkScroll } from 'react-scroll';
import { BsFileArrowDown } from 'react-icons/bs';
import EditionComp from '../../components/editionComp';
import EditionCompEN from '../../components/editionCompEN';
import { data } from '../../data/edtionData';
import { dataEN } from '../../data/editionDataEN';
import { useTranslation } from 'react-i18next';

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

const Editions = () => {
    const { i18n } = useTranslation();

    const onLoad = () => {
        gsap.timeline().fromTo("#on",
            { y: 50, opacity: 0 },
            { y: 0, opacity: 1, duration: 1.5 }
        );
    };

    useEffect(() => {
        onLoad();
    }, []);

    // Select the correct dataset based on the language
    const selectedData = i18n.language === "FR" ? data : dataEN;
    const title = i18n.language === "FR" ? "Editions précédentes" : "Previous editions";
    return (
        <div>
            <Navbar scroll='false' color='transparent' />
            <div className='editions' id='part'>
                <div className='editions-home'>
                    <div className='editions-title'>
                        <h1 id='on'>{title}</h1>
                    </div>
                    <LinkScroll to='edition' smooth={true} offset={0} duration={1000}>
                        <BsFileArrowDown style={{ color: 'white' }} className='fleche-mazars' />
                    </LinkScroll>
                    <div className='vague'>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
                            <path fill="#ffffff" fillOpacity="1"
                                d="M0,288L60,288C120,288,240,288,360,266.7C480,245,600,203,720,208C840,213,960,267,1080,288C1200,309,1320,299,1380,293.3L1440,288L1440,320L1380,320C1320,320,1200,320,1080,320C960,320,840,320,720,320C600,320,480,320,360,320C240,320,120,320,60,320L0,320Z">
                            </path>
                        </svg>
                    </div>
                </div>
                <div id='edition'>
                    {selectedData.map((item) => (
                        i18n.language === "FR" ?
                            <EditionComp
                                key={item.id}
                                title={item.title}
                                image={item.image}
                                nb_sports={item.nb_sports}
                                nb_ecoles={item.nb_ecoles}
                                nb_part={item.nb_part}
                                color={item.color}
                                annulee={item.annulee}
                                textAnnululation={item.textAnnulation}
                            />
                            :
                            <EditionCompEN
                                key={item.id}
                                title={item.title}
                                image={item.image}
                                nb_sports={item.nb_sports}
                                nb_ecoles={item.nb_ecoles}
                                nb_part={item.nb_part}
                                color={item.color}
                                annulee={item.annulee}
                                textAnnululation={item.textAnnulation}
                            />
                    ))}
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default Editions;
